<template>
  <div class="detail-dialog__price" v-if="billingCyclePriceNumList.length > 0">
    <Price v-for="billingCyclePriceItem in billingCyclePriceNumList"
           :key="billingCyclePriceItem.price"
           class="detail-dialog__price-item"
           v-bind="$attrs"
           :currency="currencySymbol"
           :price="billingCyclePriceItem.price"
           :unit="billingCyclePriceItem.unit"/>
  </div>
</template>
<script>
import {BILLING_CYCLE, BillingCycleEnum, planTypes} from "@/common/constants";
import {compact} from "lodash";
import Price from "@/components/price.vue";
import {getCurrency, getCurrencySymbol} from "@/utils/currency";
import {mapState, mapGetters} from "vuex";
import { getPlanUnitWithCycle, planUnitMap } from '@/common/product-unit';
import {ONLINE_NOT_SUPPORT_BILLING_CYCLE} from "@/common/service/non-standard-billing-cycle-utils";
import {MIGRATE_FLOW_TYPES} from "@/plans/ZOOM_MEETING/dialog/migration-plan";

export default {
  name: "price-list",
  components: {Price},
  props: {
    planCategory: String,
    unitType: {
      type: Number,
      default: planUnitMap.user
    },
  },
  data() {
    return {
      currencySymbol: getCurrencySymbol(getCurrency()),
    }
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['currentEditPlan', 'migratePlanState', 'getSelectedPlans']),
    enableBillingCycleList() {
      let billingCycleList = [BILLING_CYCLE.MONTHLY, BILLING_CYCLE.QUARTERLY, BILLING_CYCLE.ANNUAL, BILLING_CYCLE.TWO_YEARS, BILLING_CYCLE.THREE_YEARS];
      if ([MIGRATE_FLOW_TYPES.biz2bundle, MIGRATE_FLOW_TYPES.pro2bundle].includes(this.migratePlanState?.migrateType)) {
        const bizPlusPlan = this.getSelectedPlans.find(p => p.type === planTypes.ZOOM_ONE_BUNDLE)
        const fistBillingCycle = (bizPlusPlan?.billing_cycle && bizPlusPlan.billing_cycle !== BILLING_CYCLE.ANNUAL) ? bizPlusPlan.billing_cycle : BILLING_CYCLE.MONTHLY
        billingCycleList = [fistBillingCycle, BILLING_CYCLE.ANNUAL]
      } else if (this.currentEditPlan && ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(this.currentEditPlan.billing_cycle)) {
        billingCycleList = [this.currentEditPlan.billing_cycle, BILLING_CYCLE.ANNUAL]
      }
      billingCycleList.sort((a, b) => BillingCycleEnum[a] - BillingCycleEnum[b])
      return billingCycleList
    },
    billingCyclePriceNumList() {
      return compact(this.enableBillingCycleList.map(billingCycle => {
        const plan = this.planMapFlat.find(plan => plan.category === this.planCategory && plan.billing_cycle === billingCycle);
        if (plan) {
          return {
            price: (plan.amount / 100).toFixed(2),
            unit: getPlanUnitWithCycle(plan.billing_cycle, this.unitType)
          };
        }
        return null;
      }));
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.detail-dialog {
  &__price {
    width: 100%;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    gap: 24px;

    p.price.price-component {
      flex-wrap: nowrap;
      @include media(mobile, tablet) {
        flex-wrap: wrap;
      }
    }

    &-item {
      // flex: 1;
      padding-right: 24px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;

      .price__currency {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }

      .price__int {
        font-family: $happy-display;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        color: #00053D;
        margin-right: 2px;
      }

      .price__decimal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }

      .price__unit {
        font-style: normal;
        font-weight: 450;
        font-size: 16px;
        line-height: 38px;
        color: #00053D;
        align-self: flex-end;
      }

      & + & {
        padding-right: 0;
        padding-left: 24px;
        border-left: 2px solid #B8B8C4;
      }
    }
  }
}
</style>
